<div class="chat-width-a">
    <h2 mat-dialog-title class="md-title chat-cont-a">
        <img src='../../assets/images/logoclaro2.png' style='width:32px;height:32px; vertical-align: middle;'>
        <label class='labTitle chatTitle-b'>T&eacute;rminos y Condiciones comrpra de paquetes adicionales</label>
    </h2>
    <mat-dialog-content class="chat-cont-a">
        <div class="chatJAC">
            <div class="popupbg">
                <div class="popupcont f-reg f-black roboto-r">
                    <div class="termr-t">
                        <div class="linea1">
                            • Los Paquetes Adicionales de Datos pueden ser comprados por clientes de Banda Ancha y clientes de Bundle de Voz con Internet Móvil.    
                        </div>
                        <div class="linea1">
                            • El paquete seleccionado será agregado con cargo a la próxima factura, siempre y cuando la cuenta no haya llegado a su límite de crédito, de lo contrario el pago deberá ser realizado al momento con cargo a una tarjeta de crédito.
                        </div>
                        <div class="linea1">
                            • No se podrá comprar paquetes de datos adicionales antes de que tu data haya sido bloqueada/reducida.
                        </div>
                        <div class="linea1">
                            • Son para uso local en Puerto Rico y en Estados Unidos.
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <div class="basicrow text-center">
        <div class="basicrow text-center m-top">
            <a class="btns def-i gray pull-left vcenter" (click)="this.close();">
                <span class="tabcell">
                    <i class="fa fa-angle-left" aria-hidden="true"></i> &nbsp;&nbsp;Regresar
                </span>
            </a>
        </div>
    </div>
</div>